<template>
  <div>
    <div id="subject-table">
      <table class="table table-hover ui-table mb-4 mt-2">
        <thead>
          <tr>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.main_program'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.sub_program'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.subject'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.hourlyRate'
                )
              }}
            </th>
            <th style="width: 3%" class="text-center">
              <a href="#" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(subject, index) in teacher_subject_list" :key="index">
            <td>
              <a-select
                v-model="subject.acp_id"
                :options="mainProgramList"
                @change="onMainProgramChange(subject)"
                :showSearch="true"
                :filterOption="filterOption"
                style="min-width: 200px;"
                class="ts-w-full"
              ></a-select>
              <div
                class="ts-text-red-500"
                v-if="errors.has('teacher_subject_list.' + index + '.acp_id')"
              >
                {{ errors.first('teacher_subject_list.' + index + '.acp_id') }}
              </div>
            </td>
            <td>
              <a-select
                v-model="subject.acps_id"
                :options="subProgramList(subject.acp_id)"
                @change="onSubProgramChange(subject)"
                :showSearch="true"
                :filterOption="filterOption"
                style="min-width: 200px;"
                class="ts-w-full"
              ></a-select>
              <div
                class="ts-text-red-500"
                v-if="errors.has('teacher_subject_list.' + index + '.acps_id')"
              >
                {{ errors.first('teacher_subject_list.' + index + '.acps_id') }}
              </div>
            </td>
            <td>
              <a-select
                v-model="subject.subject_id"
                :options="subjectList(subject.acps_id, subject.subject_id)"
                :showSearch="true"
                :filterOption="filterOption"
                style="min-width: 200px;"
                class="ts-w-full"
              ></a-select>
              <div
                class="ts-text-red-500"
                v-if="
                  errors.has('teacher_subject_list.' + index + '.subject_id')
                "
              >
                {{
                  errors.first('teacher_subject_list.' + index + '.subject_id')
                }}
              </div>
            </td>
            <td>
              <input
                type="number"
                class="form-control only-border-bottom"
                v-model.number="subject.hourly_rate"
              />
            </td>
            <td>
              <a
                href="#"
                class="text-danger"
                @click.prevent="removeRow(subject)"
              >
                <i class="fa fa-trash mt-2"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'subject',
  props: ['value', 'validate', 'is_appear_other_company'],
  data() {
    return {
      teacher_subject_list: [],
      subject_lists: {
        subject_id: '',
        acp_id: '',
        acps_id: '',
        hourly_rate: 0
      },
      errors: new Errors()
    }
  },
  created() {
    this.teacher_subject_list = this.value
  },
  computed: {
    ...mapState('teacherProfile', ['main_programs', 'edit_data']),
    ...mapGetters('teacherProfile', ['getSubPrograms', 'getSubject']),
    mainProgramList() {
      return this.main_programs.map(el => ({
        value: el.acp_id,
        label: el.acp_name_foreign
      }))
    },
    subProgramList: vm => apcId => {
      const sub = vm.getSubPrograms(apcId)
      if (sub.length) {
        return sub.map(el => ({
          value: el.acps_id,
          label: el.acps_name_foreign
        }))
      }
      return []
    },
    subjectList: vm => (apcsId, subjectId) => {
      const subjects = vm.getSubject(apcsId)
      const excludeSubject = vm.teacher_subject_list
        .filter(el => el.subject_id !== subjectId)
        .map(el => el.subject_id)

      if (subjects.length) {
        return subjects
          .filter(el => !excludeSubject.includes(el.subject_id))
          .map(el => ({
            value: el.subject_id,
            label: el.subject_name_foreign + ' | ' + el.subject_code
          }))
      }
      return []
    }
  },
  methods: {
    addNewRow() {
      this.teacher_subject_list.push(Object.assign({}, this.subject_lists))
    },
    removeRow(subject) {
      this.teacher_subject_list.splice(
        this.teacher_subject_list.indexOf(subject),
        1
      )
    },
    async onMainProgramChange(subject) {
      subject.acps_id = ''
      subject.subject_id = ''

      await this.$store
        .dispatch('teacherProfile/subProgram', subject.acp_id)
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async onSubProgramChange(subject) {
      subject.subject_id = ''
      await this.$store
        .dispatch('teacherProfile/subject', {
          acps_id: subject.acps_id,
          is_appear_other_company: this.is_appear_other_company
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    value: {
      handler() {
        this.teacher_subject_list = this.value
      }
    }
  }
}
</script>

<style lang="css" scoped>
#subject-table {
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#subject-table::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
#subject-table::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
